import { createReducer } from '../../app/common/util/reducerUtil';
import { FETCH_ALL_CLIENTS } from './clientsConstants';

const initialState = {};

export const fetchAllClientsData = (state, payload = {}) => {
	return payload;
};

export default createReducer(initialState, {
	[FETCH_ALL_CLIENTS]: fetchAllClientsData
});
